import { apiClient } from "./apiClient";

const ENDPOINT = "vanilla";

export const getStructures = (instrumentId: number) =>
  apiClient(`${ENDPOINT}/structures`).fetchWithParams(`?instrumentId=${instrumentId}`);

export const getComponents = (structureId: number) =>
  apiClient(`${ENDPOINT}/components`).fetchWithParams(`?structureId=${structureId}`);

export const getQuoteDetails = (quoteId: number) =>
  apiClient(`${ENDPOINT}/quote`).fetchWithParams(`?quoteId=${quoteId}`);

export const saveQuoteDetails = (data: any) => apiClient(`${ENDPOINT}/quote`).post(data);

export const getQuote = (quoteId: number, priceOverride?: number, feeOverride?: number) =>
  apiClient(`${ENDPOINT}/quote`).put({ quoteId, priceOverride, feeOverride });
